import script from "./MenuItems.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItems.vue?vue&type=script&setup=true&lang=js"

import "./MenuItems.vue?vue&type=style&index=0&id=46cd0b7a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46cd0b7a"]])

export default __exports__